export default [
  {
    id: 1,
    textDropDownEn: "--Choose--",
  },

  {
    id: 2,
    textDropDownEn: "Done",
  },

  {
    id: 3,
    textDropDownEn: "Not Done",
  },
];
